import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { VehicleModelService } from '../../../../components/crud-vehicle-module-cars/services/vehicle-model.service';
import Swal from 'sweetalert2';

interface VehicleDocumentation {
  soatExpirationDate: string;
  technicalReviewExpirationDate: string;
  soatEvidenceBase64: string;
  technicalReviewEvidenceBase64: string;
  nextOilChangeKm: number;
}

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrl: './documentation.component.css',
})
export class DocumentationComponent implements OnInit {
  vehicleId: string = '';
  documentation: VehicleDocumentation = {
    soatExpirationDate: '',
    technicalReviewExpirationDate: '',
    soatEvidenceBase64: '',
    technicalReviewEvidenceBase64: '',
    nextOilChangeKm: 0,
  };
  isEditing: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vehicleModelService: VehicleModelService,
  ) {
    // do nothing
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.vehicleId = params['id'];
      if (this.vehicleId) {
        this.loadVehicleDetails();
      }
    });
  }

  async loadVehicleDetails() {
    try {
      const vehicles = await this.vehicleModelService.getVehicleModels();
      const currentVehicle = vehicles.find((v) => v.id === this.vehicleId);

      if (currentVehicle?.details) {
        this.documentation = {
          soatExpirationDate: currentVehicle.details.soatExpirationDate || '',
          technicalReviewExpirationDate: currentVehicle.details.technicalReviewExpirationDate || '',
          soatEvidenceBase64: currentVehicle.details.soatEvidenceUrl || '',
          technicalReviewEvidenceBase64: currentVehicle.details.technicalReviewEvidenceUrl || '',
          nextOilChangeKm: currentVehicle.details.nextOilChangeKm || 0,
        };
      }
    } catch (error) {
      console.error('Error al cargar los detalles del vehículo:', error);
      this.showMessage('Error al cargar los detalles del vehículo', 'error');
    }
  }

  async saveDocumentation() {
    try {
      const dataToSend = {
        soatExpirationDate: this.documentation.soatExpirationDate,
        technicalReviewExpirationDate: this.documentation.technicalReviewExpirationDate,
        soatEvidenceBase64: this.documentation.soatEvidenceBase64 || '',
        technicalReviewEvidenceBase64: this.documentation.technicalReviewEvidenceBase64 || '',
        nextOilChangeKm: this.documentation.nextOilChangeKm,
      };

      await this.vehicleModelService.updateVehicleDetails(this.vehicleId, dataToSend);
      this.showMessage('Documentación actualizada correctamente', 'success');
      this.isEditing = false;
    } catch (error) {
      console.error('Error al actualizar la documentación:', error);
      this.showMessage('Error al actualizar la documentación', 'error');
    }
  }

  onFileSelected(event: any, type: 'soat' | 'technical') {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        if (type === 'soat') {
          this.documentation.soatEvidenceBase64 = e.target.result;
        } else {
          this.documentation.technicalReviewEvidenceBase64 = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  showMessage(msg = '', type = 'success') {
    const toast: any = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      customClass: { container: 'toast' },
    });
    toast.fire({
      icon: type,
      title: msg,
      padding: '10px 20px',
    });
  }

  goBackVehicle() {
    this.router.navigate(['/vehicle']);
  }
}
